import { authHeader } from '../authservice/auth-header';
import axios from 'axios';
import { activeWaiterCode } from '../waiterservice/waiter-session';
import { activeSolutionKeyForUser } from '@/suite/solutions';

export const orderService = {
    newOrder,
    activesToday,
    activesByDate,
    itemsMenu,
    itemsMenuBySolution,
    addItemMenuToOrden,
    delSameItemMenuToOrden,
    sendOrderToKitchen,
    kitchenOrders,
    prepareOrder,
    terminateOrder,
    deliverOrder,
    deleteOrder,
    markOrderItemDone,
    generateFileInvoice,
    getInfoClientByNIT,
    searchCustomersByNit,
    saveCheckoutCustomer,
    getOrderReceiptConfig,
    downloadVoucherPdf,
    makePayment,
    makePaymentNoCardPartial,
    listReceivables,
    payReceivable,
    makeSetToPrint,
    makeDoFel
};

function newOrder(orderData = {}) {
    const waiterCode = orderData.waiterCode || activeWaiterCode();
    const solutionKey = orderData.solutionKey || currentSolutionKey();
    return new Promise(function(resolve){
        axios.post(`${process.env.VUE_APP_API}/api/order`,{
            mesa: orderData.mesa !== undefined ? orderData.mesa : 0,
            idCompany: orderData.idCompany || null,
            floorplanId: orderData.floorplanId || null,
            tableUid: orderData.tableUid || null,
            tableLabel: orderData.tableLabel || null,
            solutionKey,
            waiterCode,
        },{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data)
        })
        .catch(error => {
            resolve(normalizeAxiosError(error))
        })
    })
}

function listReceivables(params = {}) {
    const query = new URLSearchParams({
        mode: params.mode || "pending",
        solutionKey: params.solutionKey || currentSolutionKey(),
    });
    if (params.idCompany) {
        query.set("idCompany", params.idCompany);
    }
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/receivables?${query.toString()}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data.items || [])
        })
    })
}

function payReceivable(idOrder, payment) {
    return new Promise(function(resolve){
        axios.post(`${process.env.VUE_APP_API}/api/order/${idOrder}/receivable/payment`, payment,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function activesToday() {
    const waiterCode = activeWaiterCode();
    const params = new URLSearchParams({solutionKey: currentSolutionKey()});
    if (waiterCode) {
        params.set("waiterCode", waiterCode);
    }
    const query = `?${params.toString()}`;
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/actives/today${query}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data.items)
        })
    })
}

function activesByDate(bodyFind) {
    const query = new URLSearchParams({
        datefind: bodyFind.dateFind,
        solutionKey: bodyFind.solutionKey || currentSolutionKey(),
    });
    if (bodyFind.idCompany) {
        query.set('idCompany', bodyFind.idCompany);
    }
    const waiterCode = bodyFind.waiterCode || activeWaiterCode();
    if (waiterCode) {
        query.set('waiterCode', waiterCode);
    }

    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/actives?${query.toString()}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data.items)
        })
    })
}

function itemsMenu() {
    return itemsMenuBySolution(currentSolutionKey())
}

function itemsMenuBySolution(solutionKeyOverride) {
    const query = new URLSearchParams({solutionKey: solutionKeyOverride || currentSolutionKey()}).toString();
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/item?${query}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data.items)
        })
    })
}

function addItemMenuToOrden(idOrden,idItem,observations,table,promotion = null, solutionKeyOverride = null) {
    const waiterCode = activeWaiterCode();
    return new Promise(function(resolve){
        axios.put(`${process.env.VUE_APP_API}/api/order/${idOrden}/menuitem/${idItem}`,{
            "mesa": table,
            "observaciones":observations,
            "promotion": promotion,
            "solutionKey": solutionKeyOverride || currentSolutionKey(),
            waiterCode,
        },{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data)
        })
        .catch(error => {
            resolve(normalizeAxiosError(error))
        })
    })
}

function currentSolutionKey() {
    try {
        return activeSolutionKeyForUser(JSON.parse(localStorage.getItem("user") || "{}"));
    } catch (error) {
        return localStorage.getItem("activeSolutionKey") || "tootable";
    }
}

function delSameItemMenuToOrden(idOrden,position) {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/position/${position}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data)
        })
    })
}

function sendOrderToKitchen(idOrden) {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/kitchen`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function kitchenOrders() {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/to/approve/kitchen`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data.items || [])
        })
    })
}

function prepareOrder(idOrden) {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/preparing`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function terminateOrder(idOrden) {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/terminate`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function deliverOrder(idOrden) {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/delivered`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function deleteOrder(idOrden) {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/eliminate`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function markOrderItemDone(idOrden, nameItem, position) {
    return new Promise(function(resolve){
        axios.put(`${process.env.VUE_APP_API}/api/order/${idOrden}/item/done`,{
            nameItem,
            position
        },{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function generateFileInvoice(idOrden) {
    console.log(idOrden)
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/print`,{
            headers: authHeader(),
            responseType: 'blob'
        })
        //.then(handleResponse)
        .then(data => {
            var file = new Blob([data], {
                type: 'blob'
            });
            //trick to download store a file having its URL
            var fileURL = window.URL.createObjectURL(file);
            var a = document.createElement('a');
            a.href = fileURL;
            a.target = '_blank';
            a.download = 'PrintFile.pdf';
            document.body.appendChild(a); //create the link "a"
            a.click(); //click the link "a"
            document.body.removeChild(a);
            resolve(true)
        })
    })
}

function getInfoClientByNIT(nit, params = {}) {
    const query = new URLSearchParams({solutionKey: params.solutionKey || currentSolutionKey()});
    if (params.idCompany) {
        query.set("idCompany", params.idCompany);
    }
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/efact/client/${nit}?${query.toString()}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data)
        })
    })
}

function searchCustomersByNit(nit, params = {}) {
    const query = new URLSearchParams({
        nit: nit || "",
        solutionKey: params.solutionKey || currentSolutionKey(),
    });
    if (params.idCompany) {
        query.set("idCompany", params.idCompany);
    }
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/customer/search?${query.toString()}`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function saveCheckoutCustomer(customer) {
    return new Promise(function(resolve){
        axios.post(`${process.env.VUE_APP_API}/api/customer`,{
            idCompany: customer.idCompany || null,
            solutionKey: customer.solutionKey || currentSolutionKey(),
            nit: customer.nit || "",
            name: customer.name || "",
            lastName: customer.lastName || "",
            address: customer.address || "",
            email: customer.email || "",
            phone: customer.phone || "",
        },{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function getOrderReceiptConfig(idOrden) {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/receipt-config`,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            resolve(data)
        })
    })
}

function downloadVoucherPdf(idOrden) {
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/print?download=1&t=${Date.now()}`,{
            headers: authHeader(),
            responseType: "blob"
        })
        .then(response => {
            resolve(response)
        })
    })
}

function makePayment(idOrden, dataPayment){
    return new Promise(function(resolve, reject){
        try{
            const path = dataPayment && dataPayment.factura === true ? "doPayment" : "doPayment/no/fact";
            axios.put(`${process.env.VUE_APP_API}/api/order/${idOrden}/${path}`,dataPayment,{
                headers: authHeader()
            })
            .then(handleResponse)
            .then(data => {
                console.log(data)
                resolve(data)
            })
        }catch(e){
            console.log("ERROR EN makePayment")
            console.log(e)
            reject(false)
        }
    })
}

function makePaymentNoCardPartial(idOrden, dataPayment){
    return new Promise(function(resolve){
        axios.put(`${process.env.VUE_APP_API}/api/order/${idOrden}/doPayment/efectivo/partial`,dataPayment,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data)
        })
    })
}

function makeSetToPrint(idOrden, dataPayment){
    return new Promise(function(resolve){
        axios.get(`${process.env.VUE_APP_API}/api/order/${idOrden}/set/to/print`,dataPayment,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data)
        })
    })
}

function makeDoFel(idOrden, body){
    return new Promise(function(resolve){
        axios.put(`${process.env.VUE_APP_API}/api/order/${idOrden}/do/fel`,body,{
            headers: authHeader()
        })
        .then(handleResponse)
        .then(data => {
            console.log(data)
            resolve(data)
        })
    })
}

function handleResponse(response) {
    return new Promise(function(resolve,reject){
        if (response.status === 401) {
            reject(response)
        }else{
            resolve(response.data)
            /*
            if(response.data.valid){
                resolve(response.data)
            }else{
                reject(response.data)
            }
            */
        }
    })
}

function normalizeAxiosError(error) {
    if (error && error.response && error.response.data) {
        return {
            valid: false,
            status: error.response.status,
            msg: error.response.data.msg || error.response.data.message || "No se pudo completar la solicitud.",
            data: error.response.data,
        }
    }

    return {
        valid: false,
        status: 0,
        msg: error && error.message ? error.message : "No hay comunicación con el servidor.",
    }
}
